import { MenuType } from '@shared/interfaces/menu/menuType.interface';
import { Injectable } from '@angular/core';
import { HeaderService } from './header.service';
import { Router } from '@angular/router';
import { ItemMenu } from '@shared/models/item-menu.model';
import { RoutesPath } from '@shared/routes-path';
import { Config } from '@shared/config';
import { StorageService } from './storage.service';
import { logMcdDiagnosticsOnce } from '@shared/mcd-diagnostics';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(
    public header: HeaderService,
    public router: Router,
    public storage: StorageService
  ) {}

  uboNumber: any = MenuType;
  isUkraineUrl() {
    var ukraineUrl = false;
    const ukraineArr = ['helpukraine', 'how-to-help-ukraine', 'help-ukraine'];
    const matchedRoutes = ukraineArr.filter((item) => this.isActive(item));
    const eventCategory = this.header.eventCategory;
    const isAuthFromUkraine = this.header.isAuthFromUkraine;

    if (matchedRoutes.length > 0 || eventCategory || isAuthFromUkraine) {
      ukraineUrl = true;
    }

    logMcdDiagnosticsOnce(
      'MenuService.isUkraineUrl',
      `${this.router.url}|${matchedRoutes.join(',')}|${eventCategory}|${isAuthFromUkraine}`,
      {
        url: this.router.url,
        ukraineUrl,
        matchedRoutes,
        headerEventCategory: eventCategory,
        storageIsAuthFromUkraine: isAuthFromUkraine,
        isMcdEmployee: this.storage.isMcdEmployee,
      }
    );

    return ukraineUrl;
  }

  private menuType() {
    var menuType = MenuType.Default;
    if (this.isUkraineUrl()) {
      menuType = MenuType.HelpUkraine;
    }
    if (this.isWcd()) {
      menuType = MenuType.WorldCleanupDay;
    }
    // if (this.isBackbase()) {
    //   menuType = MenuType.BackBase;
    // }
    const isMcdEmployee = this.isMcd();
    if (isMcdEmployee) {
      menuType = MenuType.Mcd;
    }
    logMcdDiagnosticsOnce(
      'MenuService.menuType',
      `${menuType}|${isMcdEmployee}|${this.router.url}`,
      {
        menuType,
        menuTypeName: MenuType[menuType],
        isMcdEmployee,
        url: this.router.url,
      }
    );
    return menuType;
  }

  isMcd() {
    return this.storage.isMcdEmployee;
  }

  isWcd() {
    var wcdUrl = false;
    const wcdArr = ['worldcleanupday'];
    if (wcdArr.filter((item) => this.isActive(item)).length > 0 || this.header.isAuthFromWcd) {
      wcdUrl = true;
    }
    return wcdUrl;
  }

  isBackbase() {
    var BackbaseUrl = false;
    const backbaseArr = ['backbase'];
    if (
      backbaseArr.filter((item) => this.isActive(item)).length > 0 ||
      this.header.isAuthFromBackbase
    ) {
      BackbaseUrl = true;
    }
    return BackbaseUrl;
  }

  facebookLink() {
    var fbLink = Config.SOCIAL_LINK_FACEBOOK;
    if (this.isUkraineUrl()) {
      fbLink = Config.HEROTOHERO_LINK_FACEBOOK;
    }
    return fbLink;
  }

  instagramLink() {
    var instaLink = Config.SOCIAL_LINK_INSTAGRAM;
    if (this.isUkraineUrl()) {
      instaLink = Config.HEROTOHERO_LINK_INSTAGRAM;
    }
    return instaLink;
  }

  loadMenu() {
    var menuItems: ItemMenu[] = [];
    switch (this.menuType()) {
      case MenuType.HelpUkraine:
        menuItems = this.loadUaMenu();
        break;
      case MenuType.WorldCleanupDay:
        menuItems = this.loadWCDMenu();
        break;
      // case MenuType.BackBase:
      //   menuItems = this.loadBackbaseMenu();
      //   break;
      case MenuType.Mcd:
        menuItems = this.loadMcdMenu();
        break;
      default:
        menuItems = this.loadStandardMenu();
        break;
    }
    return menuItems;
  }

  private loadStandardMenu() {
    return [
      new ItemMenu('HEADER.LINKS.how_it_works', RoutesPath.default.how_it_works),
      new ItemMenu('HEADER.LINKS.events', RoutesPath.default.events),
      new ItemMenu('WCD.title', RoutesPath.default.worldcleanupday),
      new ItemMenu('HEADER.LINKS.MCD', RoutesPath.default.mcd_verified),
      new ItemMenu('HEADER.LINKS.blog', RoutesPath.default.articles),
    ];
  }

  // Same as loadStandardMenu(), minus the WCD link, for McD employee accounts.
  private loadMcdMenu() {
    return [
      new ItemMenu('HEADER.LINKS.how_it_works', RoutesPath.default.how_it_works),
      new ItemMenu('HEADER.LINKS.events', RoutesPath.default.events),
      new ItemMenu('HEADER.LINKS.MCD', RoutesPath.default.mcd_verified),
      new ItemMenu('HEADER.LINKS.blog', RoutesPath.default.articles),
    ];
  }

  private loadUaMenu() {
    return [
      new ItemMenu('HEADER.LINKS.how_it_works', RoutesPath.default.how_to_help_ukraine),
      new ItemMenu('FAQ.title', RoutesPath.default.help_ukraine_faq),
      new ItemMenu('HEADER.LINKS.AIRBNB', RoutesPath.default.airbnb),
      new ItemMenu('HEADER.LINKS.UKRAINE', RoutesPath.default.help_ukraine_verified),
    ];
  }

  private loadWCDMenu() {
    return [
      new ItemMenu('HEADER.LINKS.how_it_works', RoutesPath.default.how_it_works_wcd),
      new ItemMenu('HEADER.LINKS.events', RoutesPath.default.eventsWcd),
      new ItemMenu('HEADER.LINKS.cleanups', RoutesPath.default.verifiedWcd),
    ];
  }

  private loadBackbaseMenu() {
    return [
      new ItemMenu('HEADER.LINKS.backbase', RoutesPath.default.backbase),
      new ItemMenu('HEADER.LINKS.how_it_works', RoutesPath.default.how_it_works),
      new ItemMenu('HEADER.LINKS.events', RoutesPath.default.eventsBackbase),
      new ItemMenu('HEADER.LINKS.cleanups', RoutesPath.default.verifiedBackbase),
    ];
  }

  isActive(page: string) {
    return this.router.url.search(page) > 0;
  }

  getLogo() {
    var logoSrc: string;
    switch (this.menuType()) {
      case MenuType.WorldCleanupDay:
        logoSrc = 'assets/img/wcd/ldiwXph.svg';
        break;
      default:
        logoSrc = 'assets/img/logo.svg';
        break;
    }
    return logoSrc;
  }

  getHeaderLink() {
    var headerLink: string;
    switch (this.menuType()) {
      case MenuType.HelpUkraine:
        headerLink = 'helpukraine';
        break;
      case MenuType.WorldCleanupDay:
        headerLink = 'worldcleanupday';
        break;
      default:
        headerLink = RoutesPath.default.home;
        break;
    }
    return headerLink;
  }

  geType() {
    return this.menuType();
  }

  getCoverImage() {
    var coverImage: string;
    switch (this.menuType()) {
      case MenuType.HelpUkraine:
        coverImage = 'assets/img/help-ukraine/family@2x.webp';
        break;
      case MenuType.WorldCleanupDay:
        coverImage = 'assets/img/wcd/wcd_2024_login.webp';
        break;
    }
    return coverImage;
  }
}
